import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4fdb1210 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _967d7044 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _3bb92e1e = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _1a90db2d = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _24ac572e = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _47c199a4 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _e450978c = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _cf6541bc = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _ef430980 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _5ede3cf6 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _f36250aa = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _4cc6bdeb = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _672c00d4 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _e25d29a6 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _2aad51f2 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _3f48b643 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _5f41c297 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _203505dc = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _5f863e7b = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _0a9ed627 = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _4fdb1210,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _967d7044,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _3bb92e1e,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _1a90db2d,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _24ac572e,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _47c199a4,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _47c199a4,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _47c199a4,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _e450978c,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _cf6541bc,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _ef430980,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _cf6541bc,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _ef430980,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _5ede3cf6,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _5ede3cf6,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _5ede3cf6,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _5ede3cf6,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _5ede3cf6,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _5ede3cf6,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _5ede3cf6,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _f36250aa,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _f36250aa,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _4cc6bdeb,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _672c00d4,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _672c00d4,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _e25d29a6,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _2aad51f2,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _3f48b643,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _3f48b643,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _5f41c297,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _203505dc,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _5f863e7b,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _0a9ed627,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
